import { render, staticRenderFns } from "./Rozcesti.vue?vue&type=template&id=2dcdb3e4&scoped=true&"
import script from "./Rozcesti.vue?vue&type=script&lang=js&"
export * from "./Rozcesti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdb3e4",
  null
  
)

export default component.exports